import { z } from 'zod'

import { themeSchema } from '@/theme'
import { nanoidSchema } from '@/utility'

import { versionSchema } from './version/version'

export const signupDataSchema = z.object({
  uid: nanoidSchema,
  version: versionSchema,
  theme: themeSchema.optional(),
  yjsDocs: z.record(z.string(), z.string()),
  yjsReferences: z.record(z.string(), z.string()),
})

/** Data to use during user onboarding */
export type SignupData = z.infer<typeof signupDataSchema>
